import React from 'react';

import { Button } from '@/components/ui/button';
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import type { NpsCampaignSnapshot } from './types';

interface IntroStepProps {
  campaign: NpsCampaignSnapshot;
  onClose: () => void;
  onContinue: () => void;
}

const IntroStep: React.FC<IntroStepProps> = ({
  campaign,
  onClose,
  onContinue,
}) => (
  <>
    <DialogHeader>
      <DialogDescription>Pesquisa de satisfação</DialogDescription>
      <DialogTitle>{campaign.name}</DialogTitle>
    </DialogHeader>
    <p className="font-medium">{campaign.question}</p>
    <div className="space-y-3 text-sm text-muted-foreground">
      <p>Sua resposta é anônima e será usada para melhorar o transporte.</p>
      <p>Cada pessoa pode responder uma vez por campanha.</p>
      <p>
        Você poderá escolher de 1 a 20 horários relacionados à sua experiência.
      </p>
      <p className="text-destructive">
        Não inclua dados pessoais ou informações sensíveis no comentário.
      </p>
    </div>
    <DialogFooter>
      <Button variant="ghost" onClick={onClose}>
        Agora não
      </Button>
      <Button onClick={onContinue}>Começar</Button>
    </DialogFooter>
  </>
);

export default IntroStep;
